module.exports = `${require.publicPath}406.580526c4.png`;